import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"order-view","fluid":"","tag":"section"}},[_c('ViewAllOrders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }